module.exports = __webpack_public_path__ + "static/media/startButton@3x.46387ab3.png";